// 引入api
import { fun_GetAction, fun_PostAction } from "@/api";
// 引入加密方法
import "@/utils/security.js";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 抽屉状态
      drawerStatus: false,
      // 抽屉确定按钮loading状态
      loading: false,
      // 查询表单字段
      form: {
        id: null, // id
        username: null, // 用户账号
        password: null, // 用户密码
        realName: null, // 真实名称
        phone: null, // 联系电话
        department: null, // 所属机构
        state: "1", // 用户状态
        roleCode: [], // 角色
        proNum: null // 企业编号规则
      },
      // 表单提交返回的错误消息
      errRules: {
        username: null, // 用户账号
        password: null, // 用户密码
        realName: null, // 真实名称
        phone: null, // 联系电话
        department: null, // 所属机构
        state: null, // 用户状态
        roleCode: null, // 角色
        proNum: null // 企业编号规则
      },
      // 详情表单基础数据
      formConfigList: [
        {
          label: "用户账号：",
          value: "username",
          type: "input",
          required: true,
          rule: {
            required: true,
            message: "请输入用户账号",
            trigger: "blur"
          }
        },
        {
          label: "用户密码：",
          value: "password",
          type: "password",
          required: true,
          rule: {
            required: true,
            message: "请输入用户密码",
            trigger: "blur"
          }
        },
        {
          label: "用户姓名：",
          value: "realName",
          type: "input",
          required: true,
          rule: {
            required: true,
            message: "请输入用户姓名",
            trigger: "blur"
          }
        },
        {
          label: "联系电话：",
          value: "phone",
          type: "input",
          required: true,
          rule: {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          }
        },
        {
          label: "所属部门：",
          type: "slot",
          slotName: "department",
          value: "department",
          rule: {
            message: "请选择所属部门",
            trigger: "change"
          }
        },
        {
          label: "用户状态：",
          value: "state",
          type: "radio",
          required: true,
          rule: {
            required: true,
            message: "请输入用户状态",
            trigger: "blur"
          },
          option: [
            {
              label: "启用",
              value: "1"
            },
            {
              label: "废止",
              value: "0"
            }
          ]
        },
        {
          label: "角色：",
          value: "roleCode",
          type: "select",
          required: true,
          clearable: true,
          multipleValue: true,
          rule: {
            required: true,
            message: "请选择角色",
            trigger: "change"
          },
          queryParams: {
            sqlId: "6515d115-1e37-423a-91d4-80a14fe3c494"
          }
        }
        // {
        //   label: "企业编号规则：",
        //   type: "slot",
        //   slotName: "proNum",
        //   value: "proNum",
        //   required: false
        // }
      ],
      // 加密key
      key: null,
      options: [], // tree数据
      mineStatusValue: null, // el-option的value
      departmentName: null, // 所属机构名称
      // tree数据默认参数和后台给的参数对应
      defaultProps: {
        children: "children", // 子节点名称
        label: "departmentName" // 节点名称
      },
      flag: true
    };
  },

  // 模板编译完成
  mounted() {
    // 获取加密key
    this.fun_GetRSAKey();
  },

  // 自定义方法
  methods: {
    /**
     * 获取详情
     * @author 滕威
     */
    async fun_GetDetails(id) {
      this.form.id = id;
      // 获取所属机构的下拉框
      this.fun_DepartmentSelect();
      // 请求，获取结果集
      let res = await fun_GetAction("/user/detail?id=" + id);
      // 解构res.data
      const { result, data, msg } = res.data;
      // 判断请求是否成功
      if (result) {
        // 角色下拉框是多选，所以要将值转为数组
        data.roleCode = data.roleCode.split(",");
        if (data.roleCode.indexOf("agency") !== -1) {
          const obj = {
            label: "企业编号规则：",
            type: "slot",
            slotName: "proNum",
            value: "proNum",
            required: false
          };
          this.formConfigList.push(obj);
        }
        // 回显表单
        this.form = data;
        // 部门名称回显
        this.departmentName = this.form.departmentName;
        // 所属机构高亮显示
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.form.department);
        });
      } else {
        // 请求失败，提示错误信息
        this.$message.error(msg);
      }
    },
    /**
     * 表单提交
     * @author 滕威
     */
    fun_SubmitForm() {
      // 校验
      this.$refs.form.$refs.enInform.validate(valid => {
        // 校验通过
        if (valid) {
          // 打开确定按钮loading状态
          this.loading = true;
          this.form.password = window.RSAUtils.encryptedString(
            this.key,
            this.form.password
          );
          // 发起请求，获取结果集
          fun_PostAction("/user/saveOrUpdate", this.form)
            .then(res => {
              // 解构res.data
              const { result, msg, data } = res.data;
              // 判断请求是否成功
              if (result) {
                // 请求一览查询接口
                this.$parent.fun_GetList();
                // 关闭弹窗
                this.drawerStatus = false;
                // 提示信息
                this.$message.success(msg);
              } else {
                // 如果存在返回数据
                if (data != null) {
                  // 定义rules为一个随机数
                  this.errRules = Math.random();
                  // 执行延迟方法
                  this.$nextTick(() => {
                    // 提示
                    this.$message.error("请按提示修改");
                    // 赋值错误消息
                    this.errRules = data;
                  });
                  this.form.password = window.RSAUtils.decryptedString(
                    this.key,
                    this.form.password
                  );
                } else {
                  // 请求失败，提示信息
                  this.$message.error(msg);
                }
              }
              // 取消确定按钮loading状态
              this.loading = false;
            })
            .catch(() => {
              // 取消确定按钮loading状态
              this.loading = false;
            });
        } else {
          // 校验不通过，返回false，页面给出提示
          return false;
        }
      });
    },
    /**
     * 抽屉关闭时执行
     * @author 滕威
     */
    fun_DrawerClose() {
      this.formConfigList.map(e => {
        if (e.value === "proNum") {
          this.formConfigList.pop();
          this.flag = true;
        }
      });
      // 清空所属机构和角色下拉框
      // 遍历formItem
      this.$refs.form.$refs.formItem.map(e => {
        // 找到所属机构和角色下拉框
        if (e.prop === "roleCode") {
          // 置空
          e.$children[1].value = null;
        }
      });
      this.fun_Clear();
      // 清除表单验证和数据
      this.$refs.form.$refs.enInform.resetFields();
      // 关闭时，清除勾选
      this.$parent.$refs.list.$refs.multipleTable.clearSelection();
    },
    /**
     * 选择下拉框事件
     * @param {e} 选择的value值
     * @param {val} 下拉框的字段
     * @author 滕威
     */
    fun_GetSelectVal(e, val) {
      if (e.indexOf("agency") !== -1) {
        this.formConfigList.map(e => {
          if (e.value === "proNum") {
            this.flag = false;
            return;
          }
        });
        if (this.flag) {
          const obj = {
            label: "企业编号规则：",
            type: "slot",
            slotName: "proNum",
            value: "proNum",
            required: false
          };
          this.formConfigList.push(obj);
        }
      } else {
        this.formConfigList.map(e => {
          if (e.value === "proNum") {
            this.formConfigList.pop();
            this.flag = true;
          }
        });
      }
      // 遍历查询表单对象
      for (const key in this.form) {
        // 判断key和val是否相同
        if (key == val) {
          // 相同则复制给表单
          this.form[key] = e;
        }
      }
    },
    /**
     * 获取加密key接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(
            data.exponent,
            "",
            data.modulus
          );
        }
      });
    },
    /**
     * 获取所属机构下拉框
     */
    async fun_DepartmentSelect() {
      // 请求，获取结果集
      let res = await fun_PostAction("/department/getDepartmentListInit");
      // 解构res.data
      const { result, data, msg } = res.data;
      // 操作成功
      if (result) {
        // 赋值下拉框
        this.options = data;
      } else {
        // 请求失败，提示错误信息
        this.$message.error(msg);
      }
    },
    /**
     * 选中所属机构下拉框时执行
     * @author liqi
     */
    fun_ParentIdSelect(data) {
      // 赋值父级节点
      this.form.department = data.departmentCode;
      // 回显所属机构
      this.departmentName = data.departmentName;
    },
    /**
     * 下拉框清除选项
     */
    fun_Clear() {
      // 清除所属机构选中的父级主键
      this.form.department = null;
      // 清空所属机构名称
      this.departmentName = null;
      // 清除选中项
      this.$refs.tree.setCurrentKey(null);
    },
    fun_GetRadioVal(value, field) {
      if (field === "state") {
        if (value === "0") {
          this.formConfigList.splice(7, 0, {
            label: "推荐人数：",
            value: "ca",
            type: "input",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入推荐人数",
                trigger: "blur"
              }
            ]
          });
        } else {
          this.formConfigList.splice(7, 1);
        }
      }
    }
  }
};
